<template>
    <div>
        <globalhead></globalhead>
        <InquiryOrder></InquiryOrder>
        <globalfoot></globalfoot>
    </div>
</template>

<script>
import globalhead from '@/components/Global-Head';
import globalfoot from '@/components/Global-Foot';
import InquiryOrder from '@/components/InquiryOrder';

export default {
    components: {
        globalhead,
        globalfoot,
        InquiryOrder
    }
};
</script>
<style></style>
